var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 45,
    viewBox: "0 0 37 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 15.1177L2.20154 26.2747L8.22992 23.0736L21.3514 10.9225L11.3334 15.1177Z",
    fill: "#3E3E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7898 7.37445L10.9794 8.88122L2.20776 15.4741L10.8166 14.083L23.1646 8.91248L21.7898 7.37445Z",
    fill: "#3E3E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2905 4.07016L11.1862 7.69016L21.8024 6.2084L30.9906 0L10.2905 4.07016Z",
    fill: "#3E3E3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3388 21.62L16.3126 26.3373L26.337 22.0108L18.3701 21.5919C18.3701 21.5919 18.3482 21.6106 18.3388 21.62Z",
    fill: "#3E3E3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.514 26.5342L5.3363 36.794L14.7249 27.1156L16.3722 23.2799C15.0287 24.4115 13.7291 25.5119 12.5171 26.5342H12.514Z",
    fill: "#3E3E3E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0995 8.09971L9.26961 4.74542L1.08667 14.8708L10.0995 8.09971Z",
    fill: "#3E3E3E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6788 25.8245L8.51802 24.2271L2.61804 27.3594L10.6788 25.8245Z",
    fill: "#3E3E3E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7693 0.190674L22.8859 6.87111L24.1886 8.32787L33.2171 0.412626L32.7693 0.190674Z",
    fill: "#3E3E3E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3811 42.5147L4.48141 44.9812L31.2474 25.7589L27.7682 22.439L1.3811 42.5147Z",
    fill: "#3E3E3E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0784 1.19415L25.5353 8.68425L30.8371 9.17191L36.831 3.68564L34.0784 1.19415Z",
    fill: "#3E3E3E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6635 20.504L25.3286 20.801L35.1932 13.4578L32.0115 10.1598C29.2087 12.4825 24.4267 16.4932 19.6635 20.504Z",
    fill: "#3E3E3E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 29.0319L1.97919 30.8513L8.9314 29.6415L10.7947 26.975L0 29.0319Z",
    fill: "#3E3E3E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0824 10.2629L24.3421 9.73151L24.2544 9.80966L9.47314 23.4988L12.0599 25.4088C13.347 24.3209 18.0287 20.3696 22.6792 16.462C25.767 13.8673 28.2535 11.7853 30.0824 10.2629Z",
    fill: "#3E3E3E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.21826 16.8027L3.19745 18.8065L7.42201 18.0719L9.56404 15.4553L1.21826 16.8027Z",
    fill: "#3E3E3E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5454 27.9253L6.80188 36.9409L22.7199 24.8304L15.5454 27.9253Z",
    fill: "#3E3E3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.19754b5d6104dba92371f82b88bfc6d4.svg";
export { ForwardRef as ReactComponent };